import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VContainer,
    { attrs: { fluid: "" } },
    [
      _c(
        "b-col",
        {
          staticStyle: { display: "inline-flex" },
          attrs: { sm: "12", lg: "12" },
        },
        [
          _c("ul", { staticClass: "tree mr-4" }, [
            _c(
              "div",
              { staticClass: "lineage-container-table" },
              _vm._l(_vm.datos.tables, function (table) {
                return _c("li", { staticClass: "li-table" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          modifiers: { hover: true },
                        },
                      ],
                      staticClass: "lineage lineage-table",
                      attrs: {
                        title:
                          table.type == "TABLE"
                            ? "Table"
                            : table.type == "FILE"
                            ? "File"
                            : table.type == "DATASOURCE"
                            ? "Datasource"
                            : "Table",
                      },
                    },
                    [
                      _c("b-card-text", [
                        table.type == "DATASOURCE"
                          ? _c("img", {
                              staticClass: "pr-1",
                              attrs: {
                                src: require("@/assets/data_database_icon_177024.png"),
                                width: "18",
                              },
                            })
                          : _vm._e(),
                        _c(
                          "span",
                          { staticStyle: { display: "inline-flex" } },
                          [
                            table.type == "TABLE"
                              ? _c("i", { staticClass: "material-icons h5" }, [
                                  _vm._v("grid_on"),
                                ])
                              : _vm._e(),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  table.table_name
                                    ? table.table_name
                                    : table.dbname
                                    ? table.dbname
                                    : table.name
                                )
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
                ])
              }),
              0
            ),
          ]),
          _c("ul", { staticClass: "tree" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.hover",
                    modifiers: { hover: true },
                  },
                ],
                staticClass: "lineage lineage-dataset",
                class:
                  _vm.datos.datasource && _vm.datos.datasource.focus
                    ? "lineage-focus" + (_vm.classMain ? _vm.classMain : "")
                    : "" + (_vm.classMain ? _vm.classMain : ""),
                attrs: {
                  title:
                    _vm.datos.datasource &&
                    _vm.datos.datasource.type == "DASHBOARD"
                      ? "Dashboard"
                      : "Datasource",
                },
              },
              [
                _c("b-card-text", [
                  _c("span", { staticStyle: { display: "inline-flex" } }, [
                    _vm.datos.datasource &&
                    _vm.datos.datasource.type == "DASHBOARD"
                      ? _c(
                          "span",
                          { staticStyle: { display: "inline-flex" } },
                          [
                            _c("i", { staticClass: "material-icons h5" }, [
                              _vm._v("leaderboard"),
                            ]),
                          ]
                        )
                      : _c("img", {
                          staticClass: "pr-1",
                          attrs: {
                            src: require("@/assets/data_database_icon_177024.png"),
                            width: "18",
                          },
                        }),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.datos.datasource
                            ? _vm.datos.datasource.object_name
                            : ""
                        )
                      ),
                    ]),
                  ]),
                ]),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "lineage-container-report" },
              _vm._l(_vm.datos.views, function (view) {
                return _c("li", { staticClass: "li-report" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          modifiers: { hover: true },
                        },
                      ],
                      staticClass: "lineage lineage-report",
                      attrs: { title: "View" },
                    },
                    [
                      _c("b-card-text", [
                        _c(
                          "span",
                          { staticStyle: { display: "inline-flex" } },
                          [
                            _c("i", { staticClass: "material-icons h5" }, [
                              _vm._v("dashboard"),
                            ]),
                            _c("span", [_vm._v(_vm._s(view.name))]),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
                ])
              }),
              0
            ),
          ]),
        ]
      ),
      _c("b-col", {
        staticClass: "mt-3",
        staticStyle: { "font-size": "10px" },
        attrs: { sm: "12", lg: "12" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }